import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { FaLock, FaUser, FaThumbsUp } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import Open from './step/Open';
import Contacted from './step/Contacted';
import ConvertedPCV from './step/ConvertedPCV';
import PropTypes from 'prop-types';

const ICON_MAP = {
  lock: <FaLock />,
  user: <FaUser />,
  'thumbs-up': <FaThumbsUp />
};

const NAV_ITEMS = [
  {
    icon: 'lock',
    label: 'Open',
    anchor: 'open'
  },
  {
    icon: 'user',
    label: 'Contacted',
    anchor: 'contacted'
  }, {
    icon: 'thumbs-up',
    label: 'Opportunity',
    anchor: 'opportunity'
  }
];

const NavItem = ({ index, step, handleNavs, icon, label, status }) => {
  const isActive = step === index && index <= status;
  const isDone = index < status;

  const circleClass = classNames(
    'tw-flex tw-items-center tw-justify-center tw-w-10 tw-h-10 tw-rounded-xl tw-border-2 tw-transition-all',
    isActive
      ? 'tw-bg-blue-600 tw-border-blue-600 tw-text-white'
      : isDone
        ? 'tw-bg-green-500 tw-border-green-500 tw-text-white'
        : 'tw-bg-white tw-border-slate-300 tw-text-slate-400'
  );

  return (
    <div className="tw-flex-1 tw-max-w-[160px]">
      <a
        role="button"
        tabIndex={0}
        className={classNames(
          'tw-flex tw-flex-col tw-items-center tw-gap-1 tw-font-semibold tw-cursor-pointer tw-no-underline',
          isActive ? 'tw-text-blue-600' : isDone ? 'tw-text-green-600' : 'tw-text-slate-400'
        )}
        onClick={() => handleNavs(index)}
      >
        <span className={circleClass}>
          {ICON_MAP[icon]}
        </span>
        <span className="tw-hidden md:tw-block tw-mt-1 tw-text-sm">{label}</span>
      </a>
    </div>
  );
};

NavItem.propTypes = {
  index: PropTypes.number.isRequired,
  step: PropTypes.string.isRequired,
  handleNavs: PropTypes.func.isRequired,
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired
}

const LeadStep = ({lead}) => {
  const navigate = useNavigate();
  const {status} = lead || {};
  const statusId = status?.id;
  const isContacted = statusId > 1;
  const isOpportunity = statusId === 4;

  const [step, setStep] = useState(statusId || 1)

  const handleNavs = targetStep => {
    setStep(targetStep)

    const newPath = `/crm/leads/${lead?.id}#${NAV_ITEMS[targetStep - 1].anchor}`
    navigate(newPath)
  }

  useEffect(() => {
    const hash = window.location.hash;

    const matchingNavItemIndex = NAV_ITEMS.findIndex(item => `#${item.anchor}` === hash);

    if (matchingNavItemIndex !== -1) {
      setStep(matchingNavItemIndex + 1)
    }
  }, [navigate])

  return (
    <div className="tw-bg-white tw-rounded tw-shadow-sm tw-overflow-hidden tw-border tw-border-solid tw-border-slate-200">
      <div className="tw-bg-slate-50 tw-px-4 tw-pt-3 tw-pb-2 tw-border-b tw-border-solid tw-border-slate-200">
        <div className="tw-flex tw-justify-center tw-gap-4">
          {NAV_ITEMS.map((item, index) => (
            <NavItem
              key={item.label}
              index={index + 1}
              step={step}
              handleNavs={handleNavs}
              icon={item.icon}
              label={item.label}
              status={statusId}
            />
          ))}
        </div>
      </div>

      <div className="tw-font-normal tw-px-3 tw-py-4">
        {step === 1 && (
          <Open lead={lead} />
        )}
        {step === 2 && isContacted && (
          <Contacted lead={lead} />
        )}
        {step === 3 && isOpportunity && (
          <ConvertedPCV lead={lead} />
        )}
      </div>
    </div>
  )
};

LeadStep.propTypes = {
  lead: PropTypes.object.isRequired
}

export default LeadStep;
